import { UserInformation } from "../store/user/types";
import CookiesKeys, { cookieStorage } from "./cookies";

export const getToken = (): string | null => {
  return localStorage.getItem(CookiesKeys.TokenKey);
};

export const login = (token: string) => {
  localStorage.setItem(CookiesKeys.TokenKey, token);
};

export const logout = () => {
  localStorage.removeItem(CookiesKeys.TokenKey);
  removeloginCookie();
  window.location.reload();
};

export const getTokenCookie = (): string | null => {
  return cookieStorage.getItem(CookiesKeys.TokenKey);
};

export const loginCookie = (token: string) => {
  cookieStorage.setItem(CookiesKeys.TokenKey, token);
};
export const credentialsCookie = (id: string,user:string,password:string) => {
  cookieStorage.setItem(CookiesKeys.Id, id);
  cookieStorage.setItem(CookiesKeys.User, user);
  cookieStorage.setItem(CookiesKeys.Password, password);
};

export const tenantCookie = (id: string,) => {
  cookieStorage.setItem(CookiesKeys.Tenant, id);
};
export const getIdCookie = (): string | null => {
  return cookieStorage.getItem(CookiesKeys.Id);
};
export const getTenantCookie = (): string | null => {
  return cookieStorage.getItem(CookiesKeys.Tenant);
};
export const getUserCookie = (): string | null => {
  return cookieStorage.getItem(CookiesKeys.User);
};
export const getPasswordCookie = (): string | null => {
  return cookieStorage.getItem(CookiesKeys.Password);
};
export const removeloginCookie = () => {
  cookieStorage.removeItem(CookiesKeys.TokenKey);
};
export const removePasswordCookie = () => {
  cookieStorage.removeItem(CookiesKeys.Password);
};

export const modulesCookie = (id: string,) => {
  cookieStorage.setItem(CookiesKeys.Modules, id);
};
export const rolCookie = (id: string,) => {
  cookieStorage.setItem(CookiesKeys.Rol, id);
};
export const getModulesCookie = (): string | null => {
  return cookieStorage.getItem(CookiesKeys.Modules);
};
export const getRolCookie = (): string | null => {
  return cookieStorage.getItem(CookiesKeys.Rol);
};

export const setUserInfo = (user: UserInformation) => {
  cookieStorage.setItem(CookiesKeys.RolId, user.groupId);
};

export const getAllUserInfo = (): UserInformation | null => {
  const user = cookieStorage.getItem(CookiesKeys.UserInfo);
  return user ? JSON.parse(user) : null;
};

export const setAllUserInfo = (user: UserInformation) => {
  cookieStorage.setItem(CookiesKeys.UserInfo, JSON.stringify(user));
};

export const getRolIdCookie = (): string | null => {
  return cookieStorage.getItem(CookiesKeys.RolId);
};


export const isAuthenticated = () => {  
  const accessToken = cookieStorage.getItem("tokenKey");
  if(accessToken){
    return true;
  }
  return false;
};

